module.exports = __webpack_public_path__ + "static/media/bill_vigyor_80px.e6cea71d.svg";